<div class="tab-pane" role="tabpanel" id="ampliacion">
    <fieldset id="agregar_ampliacion" class="">
        <div class="step_section">
            <div class="row" id="row">
                <div class="col-md-12" id="content">
                    <form [formGroup]="form">
                        <h3 class="form-signin-heading"><strong>Autorizaciones Especiales</strong></h3>
                        <hr>
                        <div class="form-horizontal" >
                            <div class="form-group" align="left">
                                <label  for="uso_publico" class="col-md-2">Edificio de Uso P&uacute;blico:</label>
                                <div class="col-md-6">
                                    <mat-radio-group formControlName="uso_publico" (change)="add_uso_publico()">
                                        <mat-radio-button style="padding-right: 20px" name="uso_publico" value="todo">TODO</mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="uso_publico" value="parte">PARTE</mat-radio-button>
                                        <mat-radio-button style="padding-right: 20px" name="uso_publico" value="no">NO</mat-radio-button>
                                    </mat-radio-group>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </div>
    </fieldset>
</div>